// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__GjorB","inputWrap":"Table_inputWrap__OyFyi","col":"Table_col__3SMTy","bmiTooltip":"Table_bmiTooltip__2iyiI"};